import {
  MedicareBridgeCaseView,
  MedicareBridgeEligibilityReview,
} from './medicare-bridge.types';

type VisibilityFields = Pick<MedicareBridgeCaseView, 'identification' | 'status'>;

/**
 * Ruled-out identification hides the case everywhere, even while status is
 * still OPEN. The visit panel and follow-up still show a closed case's history.
 */
export function isBridgeCaseShown(
  bridgeCase: VisibilityFields | null | undefined,
): bridgeCase is VisibilityFields {
  return Boolean(bridgeCase) && bridgeCase?.identification !== 'RULED_OUT';
}

/** Status surfaces (call header, patient profile, prep) only show a case the provider can still act on. */
export function isBridgeCaseOpen(
  bridgeCase: VisibilityFields | null | undefined,
): boolean {
  return isBridgeCaseShown(bridgeCase) && bridgeCase.status === 'OPEN';
}

export function isBridgeReviewUnfinished(
  eligibilityReview: MedicareBridgeEligibilityReview,
): boolean {
  return (
    eligibilityReview === 'NOT_STARTED' ||
    eligibilityReview === 'NEEDS_INFORMATION'
  );
}

/** Whether the provider still has Bridge work to do on this case. */
export function isBridgeActionNeeded(
  bridgeCase: Pick<
    MedicareBridgeCaseView,
    'identification' | 'status' | 'eligibilityReview'
  >,
): boolean {
  if (!isBridgeCaseOpen(bridgeCase)) return false;
  return (
    bridgeCase.identification === 'SUSPECTED' ||
    isBridgeReviewUnfinished(bridgeCase.eligibilityReview)
  );
}
